import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  houseRouter: Array<RouteRecordRaw> = [
    {
        path: '/house',
        name: '商城可视化',
        component: Layout,
        redirect: '/house/scene-list',
        meta: { title: '商城可视化', icon: 'icon-invoice', alwaysShow: true },
        children: [
            {
                path: 'scene-list',
                name: '主题场景配置',
                component: () => import('@/views/house/SceneList.vue'),
                meta: { title: '主题场景配置', keepAlive: true }
            },
            {
                path: 'scene-detail',
                name: '主题场景详情',
                component: () => import('@/views/house/SceneDetail.vue'),
                meta: { title: '主题场景详情' }
            },
            {
                path: 'cake-second',
                name: '蛋糕页配置',
                component: () => import('@/views/house/cakeSecond/Index.vue'),
                meta: { title: '蛋糕页配置' }
            },
            {
                path: 'cake-second-icon-products',
                name: '蛋糕页ICON商品管理',
                component: () => import('@/views/house/cakeSecond/CakeSecondIconProducts.vue'),
                meta: { title: '蛋糕页ICON商品管理' }
            },
            {
                path: 'card-setting',
                name: '贺卡配置',
                component: () => import('@/views/house/CardSetting.vue'),
                meta: { title: '贺卡配置' }
            },
            {
                path: 'gift-card',
                name: '礼品卡管理',
                component: () => import('@/views/house/GiftCard.vue'),
                meta: { title: '礼品卡管理' }
            },
            {
                path: 'birthday-setting',
                name: '生日管家配置',
                component: () => import('@/views/house/BirthdaySetting.vue'),
                meta: { title: '生日管家配置' }
            },
            {
                path: 'image-upload',
                name: '图片资源上传',
                component: () => import('@/views/house/ImageUpload.vue'),
                meta: { title: '图片资源上传' }
            },
            {
                path: 'topic-list',
                name: '专题列表',
                component: () => import('@/views/house/topic/TopicList.vue'),
                meta: { title: '专题列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'topic-edit',
                name: '专题编辑',
                component: () => import('@/views/house/topic/TopicEdit.vue'),
                meta: { title: '专题编辑' }
            }
        ]
    }
]

export default houseRouter